import { Routes } from '@angular/router';
import { GcmErrorComponent, GcmNotfoundComponent } from '@gcm/gcm-ui-angular';
import { HomeComponent } from './components/home/home.component';
import { authGuard } from './guards/auth.guard';
import { landingTokenGuard } from './guards/landing-token.guard';

export const routes: Routes = [
  {
    path: '', pathMatch: 'full',
    canActivate: [authGuard],
    component: HomeComponent
  },
  {
    path: 'profile',
    canActivate: [landingTokenGuard],
    loadComponent: () => import('./components/profile-page/profile-page.component')
      .then(m => m.ProfilePageComponent)
  },
  { path: '404', component: GcmNotfoundComponent },
  { path: 'error', component: GcmErrorComponent },
  { path: '**', redirectTo: '/404' },
];
